import * as angular from 'angular';

import { ComponentDefinition, Log } from '../../../../models';
import { countByLevelByApp } from './countByLevelByApp';

class TableByApplicationController implements angular.IComponentController {
    table: { application: string; debug: number; info: number; warn: number; error: number; fatal: number; }[];

    readonly logs: Log[];
    readonly onCellClick: (params: { application: string; level: string; }) => void;

    static $inject = [];

    $onChanges(changesObj: angular.IOnChangesObject) {
        if (changesObj['logs']?.currentValue) {
            this.table = countByLevelByApp(this.logs);
        }
    }

    cellClick(application?: string, level?: string) {
        if (this.onCellClick) {
            this.onCellClick({ application, level });
        }
    }
}

export const wtTableByApplication: ComponentDefinition = {
    componentId: 'wtTableByApplication',
    controller: TableByApplicationController,
    template: require('./tableByApplication.component.html'),
    controllerAs: 'vm',
    bindings: {
        logs: '<',
        onCellClick: '&?'
    }
};
